import { ButtonCollapsed } from '@cian/components';
import * as React from 'react';
import Truncate from 'react-truncate';

import { useOfferSelector } from '../../hooks/selectors/useOfferSelector';
import { isBusinessSale } from '../../utils/commercial';
import { getOfferType } from '../../utils/offer_type';
import * as styles from './PossibleAssignmentDescription.css';
import { getCssSpecialtyName } from './internal/utils/getCssSpecialtyName';
import { getSpecialtyPrepared } from './internal/utils/getSpecialtyPrepared';
import { getSpecialtyTitle } from './internal/utils/getSpecialtyTitle';
import { IPossibleAssignmentDescriptionProps, THandleToggleLines } from './types';

export const PossibleAssignmentDescription: React.VFC<IPossibleAssignmentDescriptionProps> = props => {
  const { truncatedLines = 3 } = props;

  const [truncated, setTruncated] = React.useState<boolean>(false);
  const [expanded, setExpanded] = React.useState<boolean>(false);

  const offer = useOfferSelector();

  const offerType = getOfferType(offer);
  const specialtyTitle = getSpecialtyTitle(offerType);

  const specialtyPrepared = getSpecialtyPrepared(offer);

  const cssSpecialtyName = getCssSpecialtyName(specialtyPrepared);

  const handleToggleLines = React.useCallback<THandleToggleLines>(event => {
    event.preventDefault();

    setExpanded(value => !value);
  }, []);

  if (!specialtyPrepared?.specialtiesString || isBusinessSale(offer)) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <div className={styles['specialty']}>
        <div className={styles['specialties-title']}>{specialtyTitle}</div>
        <ul className={styles['specialties']}>
          {specialtyPrepared.specialtiesIcon?.map((iconSpecialty, index) => {
            const { icon: Icon } = iconSpecialty;

            return (
              <li data-testid="desc-specialty" key={`desc-specialty-${index}`} className={styles[cssSpecialtyName]}>
                <span className={styles['specialty-icon']}>{!!Icon && <Icon />}</span>
                <span className={styles['specialty-title']}>{iconSpecialty.title}</span>
              </li>
            );
          })}
        </ul>
        <div className={styles['specialties-text']}>
          <Truncate lines={!expanded && truncatedLines} onTruncate={setTruncated} ellipsis={<span>...</span>}>
            {`Ещё: ${specialtyPrepared.specialtiesString}`}
          </Truncate>
        </div>
        {(truncated || expanded) && (
          <div data-testid="button-collapsed">
            <ButtonCollapsed
              opened={!truncated && expanded}
              buttonText="Показать всё"
              closeButtonText="Свернуть"
              onClick={handleToggleLines}
              buttonStyle={styles['button_collapsed']}
            />
          </div>
        )}
      </div>
    </div>
  );
};

PossibleAssignmentDescription.displayName = 'PossibleAssignmentDescription';
